export const DEFAULT_IMAGE_DIR = "/images";
